const BonusHistoryModalConstant = ["4006412","400681","4006411","4006410"]
export default BonusHistoryModalConstant;